<header>
    <!-- phone-order-mode -->
    <phone-order></phone-order>
    <!-- /phone-order-mode -->
    <!-- desktop -->
    <entity-block [entityVar]="cmsTitle"></entity-block>
    <!-- end desktop -->
    <!--mobile-->
    <ng-template #mobileTpl>
        <main-header-navbar-mobile></main-header-navbar-mobile>
    </ng-template>
    <!--end mobile-->
</header>